import { render, staticRenderFns } from "./InvestView.vue?vue&type=template&id=6605f958&scoped=true&"
import script from "./InvestView.vue?vue&type=script&lang=js&"
export * from "./InvestView.vue?vue&type=script&lang=js&"
import style0 from "./InvestView.vue?vue&type=style&index=0&id=6605f958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605f958",
  null
  
)

export default component.exports